/**
 * Manual rep tap counter — used when MediaPipe cannot load (low-end device,
 * permission denied, missing camera).
 */
import { useState } from "react";

export default function ManualCounter({ exerciseName, onRepsChange }) {
  const [count, setCount] = useState(0);

  const tap = () => {
    setCount((c) => {
      const next = c + 1;
      onRepsChange?.(next);
      return next;
    });
    if (typeof navigator !== "undefined" && navigator.vibrate) navigator.vibrate(20);
  };

  return (
    <button
      type="button"
      onClick={tap}
      data-testid="pat-manual-counter"
      className="w-full h-full grid place-items-center"
      style={{
        background: "rgba(0,0,0,0.85)",
        color: "white",
        border: "1px solid rgba(255,255,255,0.18)",
        borderRadius: 16,
      }}
    >
      <div className="text-center">
        <div
          style={{
            fontFamily: '"Barlow Condensed", sans-serif',
            fontSize: 80,
            fontWeight: 900,
            lineHeight: 1,
            color: "white",
            textShadow: "0 2px 8px rgba(0,0,0,0.4)",
          }}
        >
          {count}
        </div>
        <div className="text-[14px] font-medium mt-2" style={{ color: "rgba(255,255,255,0.7)" }}>
          tap for each rep
        </div>
        <div
          className="mt-1 text-[11px] font-medium uppercase tracking-wide"
          style={{ color: "rgba(255,255,255,0.5)" }}
        >
          Manual mode · {exerciseName}
        </div>
      </div>
    </button>
  );
}
